import React from 'react';
import ProductDetailPage from './ProductDetailPage';

export default function CatFoodPage() {
  return <ProductDetailPage defaultSlug="kromix-katteknas" />;
}
